import logo from '../assets/appLogo/RetNext-Sagar.png'

const configData = {
  logo,
  APP_NAME: 'RETNEXT',
  country: 'us',
  continent: 'na',
  authorization: null,
  countryCode: '+91-',
  contactNumberLength: 10,
}
export default configData
